import React, { cloneElement, useId } from "react";
import styled from "@emotion/styled";
import { PlacesType, Tooltip as ReactTooltip } from "react-tooltip";
import {
  LabelDesktopFontFamily,
  LabelDesktopFontWeight,
  LabelDesktopFontSize,
  LabelDesktopLetterSpacing,
  LabelDesktopLineHeightPx,
  LabelDesktopTextDecoration,
} from "@ecologi/design-system";

const TooltipContent = styled(ReactTooltip)`
  font-family: ${LabelDesktopFontFamily} !important;
  font-weight: ${LabelDesktopFontWeight} !important;
  font-size: ${LabelDesktopFontSize}px !important;
  letter-spacing: ${LabelDesktopLetterSpacing}px !important;
  line-height: ${LabelDesktopLineHeightPx}px !important;
  text-decoration: ${LabelDesktopTextDecoration} !important;
  border-radius: 0px !important;
  padding: 20px !important;
  opacity: 1 !important;
  background-color: ${(props) => props.theme.colors.charcoal} !important;
  max-width: 240px;
  min-inline-size: 180px;
  * {
    opacity: 1 !important;
    background-color: ${(props) => props.theme.colors.charcoal} !important;
  }
`;

export type TooltipProps = {
  content: string;
  children: React.ReactElement;
  place?: PlacesType;
  showOnFocus?: boolean;
};

export function Tooltip({ showOnFocus = false, ...props }: TooltipProps) {
  const id = useId();
  const childWithTooltipId = cloneElement(props.children, {
    "data-tooltip-id": id,
  });

  return (
    <>
      {childWithTooltipId}
      <TooltipContent
        id={id}
        place={props.place || "top"}
        openEvents={
          showOnFocus
            ? { focus: true, click: true, mouseover: true }
            : undefined
        }
        closeEvents={showOnFocus ? { blur: true, mouseleave: true } : undefined}
      >
        {props.content}
      </TooltipContent>
    </>
  );
}
